import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigurationService, ForceBaseUrl } from 'src/app/services/configuration/configuration.service';
import { EndpointFactory } from 'src/app/services/endpoint-factory.service';

import { IEvaluationRequest, IEvaluationResult, IFinalizeInterviewRequest } from '../models/interview-handler.models';

@Injectable({
    providedIn: 'root'
})
export class InterviewHandlerEndpointService extends EndpointFactory {



    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector);
    }

    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('interview', force) + 'interview';
    }

    getServiceBaseUrlV2(force?: ForceBaseUrl) {
        return this.getBaseUrl('interview', force) + 'v2/' + 'interview';
    }

    callEvaluate(evaluationPayload: IEvaluationRequest = null): Observable<IEvaluationResult> {
        const endpointUrl = `${this.getServiceBaseUrl('WEBAPI')}/evaluate`;


        return this.http.post<IEvaluationResult>(endpointUrl, evaluationPayload)
            .pipe(
                catchError(error => {
                    return this.handleError(error);
                }));
    }






    finalizeInterview(request?: IEvaluationRequest): Observable<any> {

        const endpointUrl = `${this.getServiceBaseUrl('WEBAPI')}/finalize`;

        return this.http.post<any>(endpointUrl, request)
            .pipe(
                catchError(error => {
                    return this.handleError(error);
                }));
    }

    finalizeInterviewV2(request?: IEvaluationRequest): Observable<any> {

        const endpointUrl = `${this.getServiceBaseUrlV2('WEBAPI')}/finalize`;

        return this.http.post<any>(endpointUrl, request)
            .pipe(
                catchError(error => {
                    return this.handleError(error);
                }));
    }



    formatData<T>(url: string, data: any) {

        return this.http.post<T>(url, data)
            .pipe(
                catchError(error => {
                    return this.handleError(error);
                }));
    }
}
